import { render, staticRenderFns } from "./importContestant.vue?vue&type=template&id=184f2b2e&scoped=true&"
import script from "./importContestant.vue?vue&type=script&lang=js&"
export * from "./importContestant.vue?vue&type=script&lang=js&"
import style0 from "./importContestant.vue?vue&type=style&index=0&id=184f2b2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184f2b2e",
  null
  
)

export default component.exports